<template>
  <div class="dropdown-container">
    <MultiSelect
      v-model="selectedValues"
      :options="options"
      optionLabel="Glosa"
      optionValue="Id"
      placeholder="Selecciona Cursos"
      :class="{ 'p-invalid': mostrarErrores && error }"
      v-tooltip="tooltipOpts"
      @change="emitSelection"
      display="chip"
      :multiple="multiple"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import CursoService from '@/services/CursoService';
import { MultiSelect } from 'primevue/multiselect';

export default {
  components: {
    MultiSelect,
  },
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    tooltipOpts() {
      return {
        value: this.tooltip || '',
        position: 'bottom',
        disabled: !String(this.tooltip || '').trim(),
      };
    },
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValues = ref(props.modelValue);

    const fetchOptions = async () => {
      try {
        const response = await CursoService.get();
        options.value = response.data;
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValues.value);
    };

    onMounted(() => {
      fetchOptions();
    });

    return {
      options,
      selectedValues,
      emitSelection,
    };
  },
};
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
  max-height: 200px;
  max-width: 100%;
  overflow-y: auto;
}

.p-multiselect {
  width: 100%;
}
</style>
